import React from 'react';
import ReactDOM from 'react-dom';
import {ApolloClient, ApolloLink, HttpLink, InMemoryCache, ApolloProvider} from '@apollo/client';
import {BrowserRouter} from 'react-router-dom';
// import 'bootstrap-icons/font/bootstrap-icons.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
import './bootstrap.scss';
import './index.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'moment/locale/ru';
import App from './App';
import {SERVER_URL} from './utils/api';
import reportWebVitals from './reportWebVitals';

const httpLink = new HttpLink({
  uri: `${SERVER_URL}/graphql/`,
});

const authLink = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem('token@quiz-client');
  operation.setContext({
    headers: {
      Authorization: token ? `JWT ${token}` : '',
    },
  });
  return forward(operation);
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(httpLink),
});

const AppContainer = () => (
  <ApolloProvider client={client}>
    <BrowserRouter basename="app">
      <App />
    </BrowserRouter>
  </ApolloProvider>
);

ReactDOM.render(
  <React.StrictMode>
    <AppContainer />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
